exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn[data-v-2368faf0] {\n  height: 45px;\n  color: #fff;\n  font-size: 18px;\n  line-height: 45px;\n  text-align: center;\n  width: 80%;\n  border-radius: 4px;\n  background: #3B86D6;\n  margin: 20px auto auto;\n}\n.btn[data-v-2368faf0]:active {\n  background: #3B86D6;\n}\n.btn.disabled[data-v-2368faf0] {\n  opacity: 0.6;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2368faf0","scoped":true,"hasInlineConfig":false}!./~/vux-loader/src/after-less-loader.js!./~/less-loader/dist/cjs.js?{"sourceMap":false}!./~/vux-loader/src/style-loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/plugin/bottombtn.vue
// module id = 258
// module chunks = 1